import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { TESTIMONIALS } from '../data/site';
import Reveal, { ChapterLabel, EASE } from './Reveal';

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ChapterLabel index="04" title="Kundenstimmen" />
        <div className="mt-8 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              Was Kunden über <span className="text-brand">uns sagen</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="flex items-center gap-3" data-testid="testimonials-rating">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-brand text-brand" />
                ))}
              </div>
              <p className="text-sm font-medium text-slate-500">
                <span className="font-display text-base font-bold text-navy">5,0</span> aus Kundenbewertungen
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-card-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              className="group relative flex flex-col rounded-3xl border border-slate-200 bg-slate-50 p-8 transition-all duration-500 hover:-translate-y-2 hover:border-brand/30 hover:bg-white hover:shadow-2xl hover:shadow-navy/10"
            >
              <Quote className="h-8 w-8 text-brand/25 transition-colors duration-500 group-hover:text-brand/50" />
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-slate-600">
                „{t.text}"
              </blockquote>
              <figcaption className="mt-7 flex items-center justify-between border-t border-slate-200 pt-5">
                <div>
                  <p className="font-display text-sm font-bold text-navy">{t.name}</p>
                  <p className="mt-0.5 text-xs text-slate-400">{t.meta}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-brand text-brand" />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
